import { Injectable } from '@angular/core';
import { Api } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(protected api: Api) {

  }
  private controllerName = 'api/authentication';

  public changePassword(user: any) {
    return this.api.post(
      `${this.controllerName}/change-password`,
      { currentPassword: user.currentPassword, newPassword: user.password },
    );
  }

  requestResetPassword(email: string, isUseGlobalErrorHandler: boolean = true) {
    return this.api.post(`${this.controllerName}/request-reset-password`, { email: email }, {}, isUseGlobalErrorHandler);
  }
}
